// extracted by mini-css-extract-plugin
export var container = "Image-module--container--FjLIj";
export var imageElement = "Image-module--imageElement--31rel";
export var caption = "Image-module--caption--1V7-a";
export var show = "Image-module--show--1Yffh";
export var showFadeInDown = "Image-module--show-fade-in-down--2rj_G";
export var showFadeInUp = "Image-module--show-fade-in-up--I8nHq";
export var hideFadeOut = "Image-module--hide-fade-out--22W6i";